<main id="main" class="main__offset-header">
  <section class="container">
    <h1>EuroGeographics Open Data Licence</h1>
    <app-licence-content></app-licence-content>
  </section>
</main>
<app-footer showBackToTop="true" target="header"></app-footer>
